import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss',
  imports: [MatIconModule,FormsModule, ReactiveFormsModule,]
})
export class ChangePasswordComponent implements OnInit {
  showPassword = false;
  form: FormGroup; 
  loading:boolean =false;
  generating:boolean =false;
  isValidDetails:boolean=false;
  showNewPassword = false;
  showConfirmPassword = false;
  msgs:any;
  isManualPassword:boolean = false;
  constructor(public fb: FormBuilder,
    private messageService: MessageService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    private userService: UserService,
    private router: Router){
    this.form = fb.group({
      'userName': [{value: this.userService.getUserName(), disabled:true},Validators.required],
      'oldPwd': ['',Validators.required],
      'newPwd': ['',[Validators.required,Validators.minLength(8),
        Validators.pattern(ConstantService.passwordRegex)]],
      'confirmPwd': ['',Validators.required]
    },
    { validators:this.passwordMatchValidator })
    }
    
    ngOnInit(): void {
    }


  passwordMatchValidator:ValidatorFn=(control: AbstractControl): ValidationErrors | null =>{
    const newpwd = control.get('newPwd')?.value;
    const confirmpwd = control.get('confirmPwd')?.value;

    if(!newpwd || !confirmpwd){
      return null
    }
    if(newpwd !== confirmpwd){
      return {passwordMismatch:true};
    }
      return null;
  }

  onPasswordInput() {
    const newpwd = this.form.get('newPwd')?.value;
    const confirmpwd = this.form.get('confirmPwd')?.value;

    this.isManualPassword = !!newpwd || !!confirmpwd;
  }

  userName(){
    return this.form.get('userName')?.value;
  }

  oldPwd(){
    return this.form.get('oldPwd')?.value;
  }

  newPwd(){
    return this.form.get('newPwd')?.value;
  }

   confirmPwd(){
    return this.form.get('confirmPwd')?.value;
  }

  generateAutoPass() {
    let letters = "PQRSTUVWXYZabcdefg~!@-#$";
    let digits = "01234";
    let string = digits + letters;
    if (this.userName()) {
      string = this.userName() + string.toString().replace(".", "")
    }
    let password = [];
    password.push(digits[Math.floor(Math.random() * digits.length)]);
    password.push(letters[Math.floor(Math.random() * letters.length)])

    while (password.length < 8) {
      password.push(string[Math.floor(Math.random() * string.length)])
    }
    
    password[Math.floor(Math.random() * password.length)] = '@';
    
    let Newpassword = password.join('');
    this.form.get('newPwd')?.setValue(Newpassword);
    this.form.get('confirmPwd')?.setValue(Newpassword);

    this.userService.logUserActivity('User generated random password', 'Change-password', {
      'Text1': this.userService.getUserFirstName()  + ' triggered random password generation',
      'Text2': ''
    });
  }


  resetUserPass(){
    if(this.form.invalid){
      this.form.markAllAsTouched();
      return;
    }
    if(this.userName().length>0 &&
       this.oldPwd().length>0 &&
       this.newPwd() == this.confirmPwd()){
    this.loading = true;
    let payload = {
       "userName": this.userName(),
       "oldPassword":this.oldPwd(),
       "newPassword":this.newPwd(),
       "updatedBy":this.userService.getUserFirstName() 
     }
      this.sharedHttpClientService.postPlainText(
        this.urlsService.setAPIURl(
          APIURL.changePass
        ), payload
      ).subscribe({
          next: (res: any) => {
            let data = res;
            this.loading = false;
            this.userService.logUserActivity('Change user password', 'Change-password', {
              'Text1': ' Change user password for ' + this.userName() + ' triggered by ' +this.userService.getUserFirstName() ,
              'Text2': ''
            });
            if (data === 'New Password is Updated') {
              this.messageService.add({ severity: 'success', summary: 'User Details', detail: data });
              this.userService.logUserActivity('Change user password', 'Change-password', {
                'Text1': ' Changed user password successfully for ' + this.userName() + ' triggered by ' + this.userService.getUserFirstName() ,
                'Text2': ''
              });
              this.form.reset();
              this.router.navigate(['/login']);
            } else {
              this.messageService.add({ severity: 'success', summary: 'User Details', detail: data });
            }
          },
          error: (err: HttpErrorResponse) => {
            this.loading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed : Invalid Request' });
            this.userService.logUserActivity('Chaange user password', 'Change-password', {
              'Text1': 'Failed : Change user password for ' + this.userName() + ' triggered by ' + this.userService.getUserFirstName() ,
              'Text2': ''
            });
            this.form.reset();
          }
        })
    }
    else{
     this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter correct Details' });
    }
  }

   isValid(){ 
    this.isValidDetails =  this.userName().length>0 &&
    this.oldPwd().length>0 &&
    this.newPwd() == this.confirmPwd();

   }
  public routeTo(url: string) {
		this.router.navigate([url]);
	}

}
